import { render, staticRenderFns } from "./FacilityAdmissionsList.vue?vue&type=template&id=e7ee412e&scoped=true&"
import script from "./FacilityAdmissionsList.vue?vue&type=script&lang=js&"
export * from "./FacilityAdmissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ee412e",
  null
  
)

export default component.exports